export default {
    'contact.companyInfo.contactUs':'СВЯЖИТЕСЬ С НАМИ',
    'contact.companyInfo.h2.01':'Головной офис в Шэньчжэне',
    'contact.companyInfo.p.01':'Промышленный парк Даланг, район Лунхуа, город Шэньчжэнь, провинция Гуандун',
    'contact.companyInfo.h2.02':'Контактный телефон',
    'contact.companyInfo.p.02':'телефон: +86 18688782252, whatsApp,skype +86 18576744474',

    'contact.companyInfo.cardServer.h1':'часы работы',
    'contact.companyInfo.cardServer.p':'Наша миссия - предоставить вам первоклассный сервис.',
    'contact.companyInfo.cardServer.div1.span1':'с понедельника по субботу',
    'contact.companyInfo.cardServer.div1.span2':'8:00 ~ 22:00',
    'contact.companyInfo.cardServer.div2.span1':'Круглосуточное обслуживание клиентов',
    'contact.companyInfo.cardServer.div2.span2':'7 * 24 часа',
    'contact.companyInfo.cardServer.div3.span1':'Круглосуточные Логистические услуги',
    'contact.companyInfo.cardServer.div3.span2':'7 * 24 часа',


    'contact.form.h1':'ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ',
    'contact.form.label.name':'Фамилия Имя',
    'contact.form.label.name.placeholder':'введите имя и фамилию',
    'contact.form.label.type':'Тип консультации',
    'contact.form.label.type.placeholder':'выберите тип консультации',
    'contact.form.label.type.option.01':'Product Enquiry / Quotation',
    'contact.form.label.type.option.02':'Logistic Quotation',
    'contact.form.label.type.option.03':'Logistic Enquiry',
    'contact.form.label.type.option.04':'Customer Service',
    'contact.form.label.type.option.other':'Others',
    'contact.form.label.email':'Email',
    'contact.form.label.email.placeholder':'введите адрес своей почты',
    'contact.form.label.phone':'предпочтительный способ связи',
    'contact.form.label.phone.placeholder':'Введите, пожалуйста, номер телефона/WhatsAPP/Skype',
    'contact.form.label.content':'оставьте комментарий',
    'contact.form.label.content.placeholder':'Пожалуйста, введите ваше сообщение',
    'content.form.submit':'OK'
}